import { useProduct } from 'components/products/context';
import { useState } from 'react';
import { useField } from 'formik';
import styles from 'styles/shop/product.module.css';
import { useToggle } from 'hooks/common';
import { BottomDrawer } from 'components/shared/BottomDrawer';
import { Button as Btn, Clickable, ReactInput } from 'phoenix-components';
import { useLanguageLoader } from 'contexts/language';
import { useIsDesktop } from 'contexts/profile';
import { PopUp } from 'components/shared/PopUp';

export function CustomizationPopUp() {
  const product = useProduct();
  const [{ value: note }, , { setValue: setNote }] = useField('note');
  const [state, setState] = useState(note);
  const [open, toggleOpen] = useToggle();
  const lang = useLanguageLoader();
  const isDesktop = useIsDesktop()

  if (!product?.customizable) {
    return null;
  }

  const Component = isDesktop ? PopUp : BottomDrawer;

  return (
    <div className={styles.customizable}>
      {open && (
        <Component
          title={lang('store.headings.addCustomization')}
          onClose={toggleOpen}
          closeButton={true}
        >
          <ReactInput
            type="textarea"
            rows="6"
            placeholder={lang('store.words.customizationText')}
            value={state}
            setValue={e => setState(e)}
            label={lang('store.words.customization')}
          />
          <div className={styles.modalBtnSec}>
            <Btn
              size="large"
              label={lang('buttons.no')}
              primary={false}
              className={styles.modalBtn}
              onClick={toggleOpen}/>
            <Btn
              size="large"
              label={lang('buttons.yes')}
              className={styles.modalBtn}
              onClick={() => {
                setNote(state);
                toggleOpen();
              }}
            />
          </div>
        </Component>
      )}
      <Clickable
        onClick={toggleOpen}
        className={styles.clickableCus}
      >
        <ReactInput
          label={lang('store.headings.enterCustomizationText')}
          placeholder={lang('store.words.customizationText')}
          value={note}
          disabled={true}
          labelClass={styles.nestedInputClass}
          inputClass={styles.inputClass}
          nestedInputClass={styles.nestedInputClass}
          setValue={() => {
          }}
        />
      </Clickable>
    </div>
  );
}
